import { useTranslation } from "react-i18next";

import { PlusFeatureUpsell } from "@/components/plus-feature-upsell";
import { socialStrings as strings } from "@/i18n/features/social.i18n";

/**
 * What a free account sees when it taps Go Deeper, Make a Plan or Wrap Up.
 *
 * It explains the trade rather than just refusing: no ads is the thing being
 * paid for, and saying so is the honest version of a paywall. There is a
 * plain way out — tapping the backdrop or "Not now" returns to the decks that
 * are free, and nothing about the conversation is interrupted.
 *
 * It cannot grant anything. The locked decks were never sent to this device
 * (`conversation-deck.service.ts` filters them server-side), so this is a
 * signpost to /pricing, not a gate holding content back.
 */
export function PlusDeckUpsell({
  visible,
  onDismiss,
}: {
  visible: boolean;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();

  return (
    <PlusFeatureUpsell
      visible={visible}
      title={t(strings.deckPlusLockTitle)}
      body={t(strings.deckPlusLockBody)}
      body2={t(strings.deckPlusLockBody2)}
      cta={t(strings.deckPlusLockCta)}
      dismiss={t(strings.deckPlusLockDismiss)}
      trigger="plus_feature_attempted"
      onDismiss={onDismiss}
    />
  );
}
